import { convertBandItem } from '@/common/converter/convert-band-item'

/**
 * convert to band
 * 신형 카탈로그 응답을 구형 밴드 응답으로 변환
 * @param catalog
 * @returns {Promise<{cell_toplist: {}, gen_time: string, band: {celllist: *[], cell_type: *}, type: (*|string), version: (*|string)}>}
 */
export const convertBand = async (catalog = {}) => {
  return {
    type: catalog?.type ?? '',
    gen_time: '',
    version: catalog?.version ?? '',
    cell_toplist: {},
    band: await convertBandItem(catalog)
  }
}
